module.exports = __webpack_public_path__ + "media/images/cleaning/pro2@3x-8adb9baaa7e28cb0079df09037ce456f.jpg";